import { DefaultService } from '../generated-api';
import { AllowlistEntry } from '../generated-api';

export const getAllowlist = async (): Promise<AllowlistEntry[]> => {
  return DefaultService.getAllowlistAdminAllowlistGet();
};

export const addEmailToAllowlist = async (email: string): Promise<AllowlistEntry> => {
  return DefaultService.addEmailToAllowlistAdminAllowlistPost({ requestBody: { email } });
};

export const removeEmailFromAllowlist = async (email: string): Promise<any> => {
  return DefaultService.removeEmailFromAllowlistAdminAllowlistDelete({ requestBody: { email } });
};
